export const genderOptions = [
  { label: "زن", value: "FEMALE", id: 1 },
  { label: "مرد", value: "MALE", id: 2 },
];
